import moment from 'moment';
import get from 'lodash/get';

import getPronouns from './getPronouns';
import { formatPhoneNumber } from './stringUtils';

export const needsOnboarding = patient => {
    const onboarded = (
      patient?.completed_onboarding
      || patient?.platform_version === '1.0'
    );
    return !onboarded;
};

export const getAge = patient => {
  const dob = get(patient, 'date_birth');
  if (!dob) return null;
  const birthDate = new Date(dob);
  const now = new Date();
  let years = (now.getFullYear() - birthDate.getFullYear());
  if (now.getMonth() < birthDate.getMonth() ||
    (now.getMonth() === birthDate.getMonth() && now.getDate() < birthDate.getDate())) {
    years--;
  }
  return years;
};

export const getSignupStepNumber = patient => {
  switch (patient?.onboarding_step) {
    case 'SIGNED_UP':
      return 1;
    case '1':
      return 1;
    case 'DEPENDENT':
      return 1;
    case 'SELECTED_PROVIDER':
      return 2;
    case 'PICKED_TIME':
      return 3;
    case 'CONTACT_INFO_SAVED':
      return 4;
    case 'CONTRACT_SIGNED':
      return 5;
    case 'PAYMENT_METHOD_SAVED':
      return 6;
    case 'SCHEDULED':
      return 7;
    default:
      return '?';
  }
};

export const formatPatientName = patient => (
  `${get(patient, 'user.first_name')} ${get(patient, 'user.last_name')}`
);

export const formatProviderInitials = patient => {
  if (!patient || !patient.user || !patient.user.first_name) return null;
  const firstInitial = get(patient, 'user.first_name[0]') || '';
  const lastInitial = get(patient, 'user.last_name[0]') || '';
  return `${firstInitial}${lastInitial}`;
};

export const formatDateOfBirth = patient => {
  if (!patient?.date_birth) return null;
  const dateStr = moment(patient.date_birth).format('M/D/yyyy').toString();
  return dateStr;
};

export const formatLastSeen = patient => {
  if (!patient) return '-';
  const lastSeen = get(patient, 'patient_status.last_seen') || '';
  if (lastSeen) return moment(lastSeen).format('M/D/yyyy');
  return '';
};

export const formatPatientInitials = patient => {
  if (!patient || !patient.user || !patient.user.first_name) return null;
  const firstInitial = get(patient, 'user.first_name[0]') || '';
  const lastInitial = get(patient, 'user.last_name[0]') || '';
  return `${firstInitial}${lastInitial}`;
};

export const formatPatientPhone = (patient, config = {returnLinkText: false}) => {
  if (!patient) return null;
  const rawPhone = get(patient, 'phone') || '';
  const cleanPhone = formatPhoneNumber(rawPhone);

  if (config.returnLinkText) {
    return (<a href={`tel:${rawPhone}`}>{cleanPhone}</a>)
  }

  return cleanPhone;
};

export const formatPatientStatus = patient => (
  get(patient, 'patient_status.status') || 'None'
);

export const formatPronouns = patient => {
  const pronoun = get(patient, 'personal_pronouns');
  if (!pronoun) return '';
  const option = getPronouns().find(opt => opt.value === pronoun);
  if (!option) return '';
  return get(option, 'label') || '';
};

export const getPatientViewPath = patient => {
  return `/patients/view/${get(patient, 'id')}`;
};
